import { environment } from "./constance";

import copperVault from "src/assets/images/knight/knight-vault/rank1.png";
import silverVault from "src/assets/images/knight/knight-vault/rank2.png";
import goldVault from "src/assets/images/knight/knight-vault/rank3.png";
import diamondVault from "src/assets/images/knight/knight-vault/rank4.png";
import crystalVault from "src/assets/images/knight/knight-vault/rank5.png";

import V1Rank1Rank from "src/assets/images/knight/v1/rank1/rank.png";
import V1Rank2Rank from "src/assets/images/knight/v1/rank2/rank.png";
import V1Rank3Rank from "src/assets/images/knight/v1/rank3/rank.png";
import V1Rank4Rank from "src/assets/images/knight/v1/rank4/rank.png";
import V1Rank5Rank from "src/assets/images/knight/v1/rank5/rank.png";

const vaultConfigTestnet = {
  "copper-vault": {
    id: "copper-vault",
    name: "Copper",
    rarity: "copper",
    order: 1,
    contractAddress: "0x8D7F75a60f8351f8Dc5e3Af6830e97305590CC12",
    weeklyReward: 150000,
    collectionPrice: 4000,
  },
  "silver-vault": {
    id: "silver-vault",
    name: "Silver",
    rarity: "silver",
    order: 2,
    contractAddress: "0x0C73bF7D049EB70b6794afbbfe612B49eD66f080",
    weeklyReward: 175000,
    collectionPrice: 10600,
  },
  "gold-vault": {
    id: "gold-vault",
    name: "Gold",
    rarity: "gold",
    order: 3,
    contractAddress: "0xA91d8115bf4aa512fF9c3df08eab50cB65CB739f",
    weeklyReward: 175000,
    collectionPrice: 23600,
  },
  "diamond-vault": {
    id: "diamond-vault",
    name: "Diamond",
    rarity: "diamond",
    order: 4,
    contractAddress: "0x4AF504397F19d799D96980F62dd7aec2292927E6",
    weeklyReward: 200000,
    collectionPrice: 52000,
    polishRequired: true,
  },
  "crystal-vault": {
    id: "crystal-vault",
    name: "Crystal",
    rarity: "crystal",
    order: 5,
    contractAddress: "0x5F7fc86aa44F633148241646672a5273633d8F9A",
    weeklyReward: 300000,
    collectionPrice: 150000,
    polishRequired: true,
  },
};

const vaultConfigMainnet = {
  "copper-vault": {
    id: "copper-vault",
    name: "Copper",
    rarity: "copper",
    order: 1,
    contractAddress: "0xF328B2a5Bb7684372C9D6a2Bcb89D2be426bC152",
    weeklyReward: 350000,
    collectionPrice: 9000,
  },
  "silver-vault": {
    id: "silver-vault",
    name: "Silver",
    rarity: "silver",
    order: 2,
    contractAddress: "0xD8098C35E91C3346f463582bf571ADC983fEF3D0",
    weeklyReward: 500000,
    collectionPrice: 22000,
  },
  "gold-vault": {
    id: "gold-vault",
    name: "Gold",
    rarity: "gold",
    order: 3,
    contractAddress: "0xcb7cff1191E3f9DF46ba1C9D36C7fb6EEaE55d0e",
    weeklyReward: 700000,
    collectionPrice: 64000,
  },
  "diamond-vault": {
    id: "diamond-vault",
    name: "Diamond",
    rarity: "diamond",
    order: 4,
    contractAddress: "0xCf64493616c2DeBF81bE6791260d483864E69b1F",
    weeklyReward: 850000,
    collectionPrice: 150000,
    polishRequired: true,
  },
  "crystal-vault": {
    id: "crystal-vault",
    name: "Crystal",
    rarity: "crystal",
    order: 5,
    contractAddress: "0x53931DcF18912C2D2b1232c3F47fe42ACaABb32a",
    weeklyReward: 1000000,
    collectionPrice: 820000,
    polishRequired: true,
  },
};

export const vaultAssetsMapping = {
  copper: {
    thumbImg: copperVault,
    badge: V1Rank1Rank,
    color: "#EB7A00",
  },
  silver: {
    thumbImg: silverVault,
    badge: V1Rank2Rank,
    color: "#C8C8C8",
  },
  gold: {
    thumbImg: goldVault,
    badge: V1Rank3Rank,
    color: "#E7D600",
  },
  diamond: {
    thumbImg: diamondVault,
    badge: V1Rank4Rank,
    color: "#8125FF",
  },
  crystal: {
    thumbImg: crystalVault,
    badge: V1Rank5Rank,
    color: "#1C8CF3",
  },
};

const vaultsConfig = environment === "testnet" ? vaultConfigTestnet : vaultConfigMainnet;

export default vaultsConfig;
